const custom_profile_fields = {
    entity_not_exists_with_names: 'Cannot find entities with the given names: {{names}}',
    invalid_min_max_input: 'Invalid min and max input.',
    invalid_options: 'Invalid field options.',
    invalid_regex_format: 'Invalid regex format.',
    invalid_address_parts: 'Invalid address parts.',
    invalid_fullname_parts: 'Invalid fullname parts.',
    name_exists: 'Field already exists with the given name.',
    conflicted_sie_order: 'Conflicted field order value for Sign-in Experience.',
    invalid_name: 'Invalid field name, only letters or numbers are allowed, case sensitive.',
};
export default Object.freeze(custom_profile_fields);
